var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreatorAccount = function SvgCreatorAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.76 8.36-3.75-2.5a.469.469 0 0 0-.729.39v5a.469.469 0 0 0 .73.39l3.75-2.5a.47.47 0 0 0 0-.78M9.22 10.373V7.126l2.436 1.624zm7.656-7.093H3.125a1.094 1.094 0 0 0-1.094 1.094v8.75a1.094 1.094 0 0 0 1.094 1.094h13.75a1.094 1.094 0 0 0 1.094-1.094v-8.75a1.094 1.094 0 0 0-1.094-1.094m.156 9.844a.156.156 0 0 1-.156.156H3.125a.156.156 0 0 1-.156-.156v-8.75a.156.156 0 0 1 .156-.156h13.75a.156.156 0 0 1 .156.156zm.938 3.125a.47.47 0 0 1-.469.469h-15a.469.469 0 0 1 0-.938h15a.47.47 0 0 1 .469.469"
  })));
};
export default SvgCreatorAccount;